import logo from "./logo-3.svg";
import twitter from "./twitter.svg";
import concreteLogo from "./concrete.svg";
import glowLogo from "./glow.svg";

import "./App.css";

function App() {
  return (
    <div className="App App-header">
      <img
        src={logo}
        className="App-logo"
        alt="The logo of Blueprint Finance"
      />
      <div>
        <h1 className="text">
          Architecting the next generation of capital market solutions
        </h1>
      </div>

      <div className="platforms">
        <a href="https://www.concrete.xyz/" target="_blank" rel="noreferrer">
          <img className="logo" src={concreteLogo} alt="The logo of Concrete" />
        </a>
        <span className="amp">&amp;</span>
        <a href="https://www.glowfinance.xyz/" target="_blank" rel="noreferrer">
          <img className="logo" src={glowLogo} alt="The logo of Glow Finance" />
        </a>
      </div>

      <a className="button text" href="mailto:hello@blueprintfinance.com">
        Contact
      </a>

      <div className="socials">
        <a
          href="https://twitter.com/Blueprint_DeFi"
          target="_blank"
          rel="noreferrer"
        >
          <img src={twitter} className="twitter" alt="The Twitter logo" />
        </a>
      </div>
    </div>
  );
}

export default App;
